import { render, staticRenderFns } from "./viewPlanAndCoupon.vue?vue&type=template&id=66a61d2f&"
import script from "./viewPlanAndCoupon.vue?vue&type=script&lang=js&"
export * from "./viewPlanAndCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports